// JobInvoiceDrawer's reads and writes (finance-real, the user 2026-10-22): a draft takes more done or active jobs, and gives one
// back; its number is edited while it is a draft (answer g); its status is picked (Draft, Sent), and a payment recorded
// makes it Partly paid or Paid, or Paid in full with a withholding or a write-off (DD-062, answer e). Laid out as the
// month drawer (the user 2026-10-23), it reads its client's claims and the people for Goes out for it, where a claim is
// added, changed and removed as in the job drawer.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useAddClaim, useClientClaims, useRemoveClaim, useUpdateClaim } from "../../hooks/useJobClaims";
import { usePeople } from "../../hooks/useLedger";
import { useAddInvoiceJobs, useRecordInvoicePayment, useRemoveInvoiceJob, useSetInvoiceNumber, useSetInvoiceStatus } from "../../hooks/useLineJobs";
import type { InvoiceJobRemoved, InvoiceJobsInput, JobClaim, JobClaimInput, JobInvoice, JobInvoiceNumberInput, JobInvoicePaymentInput, JobInvoiceStatusInput, Person } from "../../types";

export interface JobInvoiceDrawerModel {
  add: UseMutationResult<JobInvoice, Error, { invoiceId: string; input: InvoiceJobsInput }>;
  remove: UseMutationResult<InvoiceJobRemoved, Error, { invoiceId: string; jobId: string }>;
  setStatus: UseMutationResult<JobInvoice, Error, { invoiceId: string; input: JobInvoiceStatusInput }>;
  /** A draft's number: a refusal shows under the field. */
  setNumber: UseMutationResult<JobInvoice, Error, { invoiceId: string; input: JobInvoiceNumberInput }>;
  pay: UseMutationResult<JobInvoice, Error, { invoiceId: string; input: JobInvoicePaymentInput }>;
  /** The client's claims: the drawer lists those on its jobs. */
  claims: UseQueryResult<JobClaim[]>;
  people: Person[];
  addClaim: UseMutationResult<JobClaim, Error, { jobId: string; input: JobClaimInput }>;
  updateClaim: UseMutationResult<JobClaim, Error, { claimId: string; input: JobClaimInput }>;
  removeClaim: UseMutationResult<JobClaim, Error, string>;
}

export function useJobInvoiceDrawer(clientId: string): JobInvoiceDrawerModel {
  const add = useAddInvoiceJobs();
  const remove = useRemoveInvoiceJob();
  const setStatus = useSetInvoiceStatus();
  const setNumber = useSetInvoiceNumber();
  const pay = useRecordInvoicePayment();
  const claims = useClientClaims(clientId);
  const people = usePeople();
  const addClaim = useAddClaim();
  const updateClaim = useUpdateClaim();
  const removeClaim = useRemoveClaim();
  return { add, remove, setStatus, setNumber, pay, claims, people: people.data ?? [], addClaim, updateClaim, removeClaim };
}
